/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
// API
import {
  getDepartmentFilter,
  getManagerFilter,
  getRepFilter,
  getDoctorFilter,
} from '../../../api/filterOptionsApi';
import {
  filterValue,
  filterDepartmentOptions,
  filterManagerOptions,
  filterRepOptions,
  filterDoctorv2Options,
} from '../../../helpers/filterFunctions';
// CONTEXT
import useTargetContext from '../context/useTargetContext';

function Filter() {
  const {
    auth,
    setFilterForm,
    filterForm,
    monthsOptions,
    yearOptions,
    searchTarget,
    clearTarget,
    changeManagerID,
  } = useContext(useTargetContext);
  const date = new Date();

  const [departmentOptions, setDepartmentOptions] = useState({ loading: false, data: [] });
  const [managerOptions, setManagerOptions] = useState({ loading: false, data: [] });
  const [repOptions, setRepOptions] = useState({ loading: false, data: [] });
  const [mdOptions, setMdOptions] = useState({ loading: false, data: [] });

  const loadDepartmentDropdown = async () => {
    const request = {
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      md_id: filterValue(filterForm?.md),
    };
    const reponse = await getDepartmentFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterDepartmentOptions(data);
      setDepartmentOptions({
        ...departmentOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadManagersDropdown = async () => {
    setManagerOptions({ loading: true, data: [] });
    const request = {
      department: filterValue(filterForm?.department),
      rep_id: filterValue(filterForm?.rep_id),
      md_id: filterValue(filterForm?.md),
    };
    const response = await getManagerFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterManagerOptions(data);
      setManagerOptions({
        ...managerOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadRepDropdown = async () => {
    setRepOptions({ loading: true, data: [] });
    const request = {
      department: filterValue(filterForm?.department),
      manager_id: filterValue(filterForm?.manager_id),
      md_id: filterValue(filterForm?.md),
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);

      setRepOptions({
        ...repOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadMDDropdown = async () => {
    setMdOptions({ loading: true, data: [] });
    const request = {
      department: filterValue(filterForm?.department),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
    };
    const response = await getDoctorFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterDoctorv2Options(data);
      setMdOptions({
        ...mdOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadDepartmentDropdown();
    loadManagersDropdown();
    loadRepDropdown();
    loadMDDropdown();
  }, []);

  return (
    <Box>
      <Grid container spacing={2}>
        {auth.designation === 'admin' ||
        auth.designation === 'sub_admin' ||
        auth?.level === 'Level 3' ||
        auth.level === 'Level 4' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              loading={departmentOptions?.loading}
              options={departmentOptions?.data}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Department' />}
              size='small'
              value={filterForm.department}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}
        {auth.designation === 'admin' ||
        auth?.level === 'admin' ||
        auth?.level === 'Level 3' ||
        auth?.level === 'Level 4' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='manager_id'
              disableClearable
              fullWidth
              loading={managerOptions?.loading}
              options={managerOptions?.data}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Managers (KASM/SAM)' />}
              size='small'
              value={filterForm?.manager_id}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager_id')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            loading={repOptions?.loading}
            options={repOptions?.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='KASS/SAR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='md'
            disableClearable
            fullWidth
            loading={mdOptions?.loading}
            options={mdOptions?.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MD Names' />}
            size='small'
            value={filterForm?.md}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'md')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='months'
            disableClearable
            multiple
            fullWidth
            options={monthsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.month ?? []}
            noOptionsText='No Months'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [monthsOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [monthsOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== monthsOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                month: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Months' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        {/* <Grid md={2}>
          <Autocomplete
            disablePortal
            id='year'
            disableClearable
            fullWidth
            options={yearOptions}
            getOptionLabel={(option) => `${option.label}`}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Year' />}
            size='small'
            value={
              filterForm.year
                ? yearOptions.find((row) => row.value === filterForm.year.value)
                : null
            }
            onChange={(e, newValue) => handleChangeYear(e, newValue)}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid> */}
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchTarget}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={clearTarget}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default Filter;
